module.exports = __webpack_public_path__ + "static/media/fix_gold.a22b7816.png";